import { lazy } from "react";

const HomePage = lazy(() => import("./RenalInsufficiencyStagePage"));

const routes = [
  {
    path: "/renal-insufficiency-stages",
    component: HomePage,
    exact: true,
    name: "Estadios de Insuficiencia Renal"
  }
];

export default routes;
